export default "__VITE_ASSET__D8Tjxo54__"